import { useState } from "react";
import api from "@/lib/api";
import { Flag } from "@phosphor-icons/react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export default function ReportButton({ targetType, targetId, className = "" }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async () => {
    if (!reason.trim()) {
      toast.error("Please describe the issue");
      return;
    }
    setSending(true);
    try {
      await api.post("/reports", {
        target_type: targetType,
        target_id: targetId,
        reason: reason.trim(),
      });
      toast.success("Report submitted. Admin will review.");
      setOpen(false);
      setReason("");
    } catch {
      toast.error("Failed to submit report");
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          data-testid={`report-btn-${targetId}`}
          className={`flex flex-col items-center gap-1 ${className}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="w-12 h-12 rounded-full glass flex items-center justify-center">
            <Flag size={22} weight="bold" className="text-white/80" />
          </div>
          <span className="text-[10px] font-bold text-white/70">Report</span>
        </button>
      </DialogTrigger>
      <DialogContent className="bg-[#121212] border-white/10 text-white max-w-sm">
        <DialogHeader>
          <DialogTitle className="font-heading">Report content</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <p className="text-sm text-white/60">
            Let admin know why this content violates community rules.
          </p>
          <Textarea
            data-testid="report-reason-input"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Spam, hate speech, misleading, etc."
            className="bg-white/5 border-white/10 text-white"
            rows={4}
          />
          <Button
            data-testid="report-submit-btn"
            onClick={submit}
            disabled={sending}
            className="w-full bg-red-600 hover:bg-red-700"
          >
            Submit report
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
